'use client';

import * as React from 'react';
export const FormContext = /*#__PURE__*/React.createContext({
  formRef: {
    current: {
      fields: new Map()
    }
  },
  errors: {},
  onClearErrors: () => {}
});
if (process.env.NODE_ENV !== 'production') {
  FormContext.displayName = 'FormContext';
}
export function useFormContext() {
  return React.useContext(FormContext);
}